/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { FSFBWebEventEntry } from './fsfbweb-event-entry';
import { FrameBundlePlatform } from './frame-bundle-platform';
import { FrameRootProto } from './frame-root-proto';
import { PreviousSessionMetadata } from './previous-session-metadata';
import { SessionRequestProto } from './session-request-proto';
import { UnloadReason } from './unload-reason';
import { WebBundleProto } from './web-bundle-proto';

export class FrameBundleRootProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FrameBundleRootProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFrameBundleRootProto(
    bb: flatbuffers.ByteBuffer,
    obj?: FrameBundleRootProto,
  ): FrameBundleRootProto {
    return (obj || new FrameBundleRootProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsFrameBundleRootProto(
    bb: flatbuffers.ByteBuffer,
    obj?: FrameBundleRootProto,
  ): FrameBundleRootProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FrameBundleRootProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  fsOrgId(): string | null;
  fsOrgId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fsOrgId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fsUserId(): string | null;
  fsUserId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fsUserId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fsSessionId(): string | null;
  fsSessionId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fsSessionId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fsPageId(): string | null;
  fsPageId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fsPageId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  unload(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  seq(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  stringTable(index: number): string;
  stringTable(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  stringTable(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  stringTableLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  canvasBundle(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  canvasBundleLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  canvasBundleArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  lastFrame(obj?: FrameRootProto): FrameRootProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new FrameRootProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  lastWebBundle(obj?: WebBundleProto): WebBundleProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new WebBundleProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  protocolVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  canvasDefinition(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  canvasDefinitionLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  canvasDefinitionArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  platform(): FrameBundlePlatform {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FrameBundlePlatform.Unknown;
  }

  attributes(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  attributesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  attributesArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  webEvents(index: number, obj?: FSFBWebEventEntry): FSFBWebEventEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new FSFBWebEventEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  webEventsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  pageStart(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('0');
  }

  lastUserActivity(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('0');
  }

  unloadReason(): UnloadReason {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : UnloadReason.Unknown;
  }

  pageData(obj?: SessionRequestProto): SessionRequestProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? (obj || new SessionRequestProto()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  previousSessionMetadata(obj?: PreviousSessionMetadata): PreviousSessionMetadata | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset
      ? (obj || new PreviousSessionMetadata()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  static startFrameBundleRootProto(builder: flatbuffers.Builder) {
    builder.startObject(20);
  }

  static addFsOrgId(builder: flatbuffers.Builder, fsOrgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, fsOrgIdOffset, 0);
  }

  static addFsUserId(builder: flatbuffers.Builder, fsUserIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, fsUserIdOffset, 0);
  }

  static addFsSessionId(builder: flatbuffers.Builder, fsSessionIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, fsSessionIdOffset, 0);
  }

  static addFsPageId(builder: flatbuffers.Builder, fsPageIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, fsPageIdOffset, 0);
  }

  static addUnload(builder: flatbuffers.Builder, unload: boolean) {
    builder.addFieldInt8(4, +unload, +false);
  }

  static addSeq(builder: flatbuffers.Builder, seq: number) {
    builder.addFieldInt32(5, seq, 0);
  }

  static addStringTable(builder: flatbuffers.Builder, stringTableOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, stringTableOffset, 0);
  }

  static createStringTableVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startStringTableVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addCanvasBundle(builder: flatbuffers.Builder, canvasBundleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, canvasBundleOffset, 0);
  }

  static createCanvasBundleVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createCanvasBundleVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createCanvasBundleVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCanvasBundleVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addLastFrame(builder: flatbuffers.Builder, lastFrameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, lastFrameOffset, 0);
  }

  static addLastWebBundle(builder: flatbuffers.Builder, lastWebBundleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, lastWebBundleOffset, 0);
  }

  static addProtocolVersion(builder: flatbuffers.Builder, protocolVersion: number) {
    builder.addFieldInt32(10, protocolVersion, 0);
  }

  static addCanvasDefinition(
    builder: flatbuffers.Builder,
    canvasDefinitionOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(11, canvasDefinitionOffset, 0);
  }

  static createCanvasDefinitionVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createCanvasDefinitionVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createCanvasDefinitionVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCanvasDefinitionVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addPlatform(builder: flatbuffers.Builder, platform: FrameBundlePlatform) {
    builder.addFieldInt8(12, platform, FrameBundlePlatform.Unknown);
  }

  static addAttributes(builder: flatbuffers.Builder, attributesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, attributesOffset, 0);
  }

  static createAttributesVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createAttributesVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createAttributesVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startAttributesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addWebEvents(builder: flatbuffers.Builder, webEventsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, webEventsOffset, 0);
  }

  static createWebEventsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startWebEventsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addPageStart(builder: flatbuffers.Builder, pageStart: bigint) {
    builder.addFieldInt64(15, pageStart, BigInt('0'));
  }

  static addLastUserActivity(builder: flatbuffers.Builder, lastUserActivity: bigint) {
    builder.addFieldInt64(16, lastUserActivity, BigInt('0'));
  }

  static addUnloadReason(builder: flatbuffers.Builder, unloadReason: UnloadReason) {
    builder.addFieldInt8(17, unloadReason, UnloadReason.Unknown);
  }

  static addPageData(builder: flatbuffers.Builder, pageDataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, pageDataOffset, 0);
  }

  static addPreviousSessionMetadata(
    builder: flatbuffers.Builder,
    previousSessionMetadataOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(19, previousSessionMetadataOffset, 0);
  }

  static endFrameBundleRootProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
